import type { Strict } from '@newfront-insurance/core';
import type { Status as NestStatus } from '@newfront-insurance/nest-api';

import { formatDate } from './dates';
import type { Status } from '../types';

export function formatStatus<S, R>(status: NestStatus<S, R>): Status<S, R> {
  return {
    ...status,
    statusDate: formatDate(status.statusDate) as string,
  };
}

export function formatStatusStrict<S, R>(status: Strict<NestStatus<S, R>>): Strict<Status<S, R>> {
  return {
    ...status,
    statusDate: formatDate(status.statusDate) as string,
  };
}
